export const customTheme= {
    fontFamily: 'Poppins',
    components: {
        Table: {
            cellPaddingBlockSM: 4,
            cellFontSizeSM: 12,
            
        },
    }
};